var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"el-loading flex center"},[_c('a-spin',{attrs:{"size":"large","tip":_vm.text || '加载中'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }